<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>All Rubrics Subject Consolidated Report</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        @change="getStd()"
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        dense
                        required
                        outlined
                        rounded
                        color="#0F2027"
                        v-model="sem"
                        :items="semester_list"
                        item-text="display_name"
                        item-value="id"
                        label="Semester"
                        persistent-hint
                        hint="Please select semester"
                        @change="putallnull()"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        return-object
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        @change="
                        getDiv();
                        getassessmentschemedetails();putnull();
                        "
                        persistent-hint
                        hint="Please select standard"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id" :items="div_list" item-text="div_name" label="Division" outlined persistent-hint hint="Please select division" />
                </v-col>
                <v-col cols="12" sm="5" md="5" v-if="assessment_detail_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="assessment_detail"
                        return-object
                        :items="assessment_detail_list"
                        item-text="assessmenttype"
                        label="Assessment Scheme Details"
                        outlined
                        persistent-hint
                        hint="Please select assessment scheme details"
                        @change="putnull3"
                    />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && assessment_detail">
                    <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <span v-if="learner_course_list != null">
                <span v-if="show">
                    <!-- <v-btn  class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn> -->
                    <v-row>
                        <!-- <v-col cols="12" sm="3" md="3">
                            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="CartPdf()"> <v-icon left>mdi-printer</v-icon> Print</v-btn>
                        </v-col> -->
                        <v-col cols="12" sm="3" md="3">
                            <v-btn rounded color="success" outlined @click="fnExcelReport('tab1', 'AllRubricsSubjectConsolidatedReport')" :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                        </v-col>
                    </v-row>
            <div id="tab">
                        <center>
                            <table dense width="1000px" class="elevation-1 table">
                                <thead>
                                    <tr>
                                        <th class="table" v-if="org_basic_data.trust_logo">
                                            <center>
                                                <img :src="org_basic_data.trust_logo" width="75%" alt="logo" />
                                            </center>
                                        </th>
                                        <th class="table">
                                            <center>
                                                <center>
                                                    <strong>
                                                        <h6>
                                                            <span v-if="org_basic_data.trust_name">{{ org_basic_data.trust_name }}</span>
                                                        </h6>
                                                    </strong>
                                                    <strong><span v-if="org_basic_data.school_name">{{ org_basic_data.school_name }}</span></strong><br />
                                                    <strong>
                                                        <h5>
                                                            {{ ass_Scheme }} ({{ academicyear }}) Rubrics Consolidated Sheet
                                                        </h5>
                                                    </strong>
                                                    <br />
                                                </center>
                                            </center>
                                        </th>
                                        <th class="table" v-if="org_basic_data.school_logo">
                                            <center>
                                                <img :src="org_basic_data.school_logo" width="50%" alt="logo" />
                                            </center>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="table" colspan="3">
                                            <v-row dense justify="center">
                                                <span class="mr-5">
                                                    <strong>
                                                        <h4>
                                                            Class : {{ standard }}  Div: <span v-for="(header, index) in division" :key="index"> {{ index+1 }}) {{ header }}</span>
                                                        </h4>
                                                    </strong>
                                                </span>
                                                <strong><h4>Exam : {{ ass_Scheme }}</h4></strong>
                                            </v-row>
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                        </center>
                    </div>
                    <div id="tab1">
                        <div class="scroll">
            <v-simple-table fixed-header height="500px" dense class="elevation-1" v-if="learner_course_list!=''">
                    <tr>
                       <th colspan="5"></th>
                        <th class=""  v-for="header,index in crs_list" :key="index" :colspan="crs_rubrics_list_size[index]">
                            <center>{{ header }}</center>
                        </th>
                        <th colspan="3"></th>
                    </tr>
                    <tr>
                       <th colspan="5"></th>
                        <th class=""  v-for="header,index in course_list" :key="index" :colspan="rubrics_list_size[index]">
                            <center>{{ header }}</center>
                        </th>
                        <th colspan="3"></th>
                    </tr>
                <tbody style="overflow-y: scroll;">
                     <tr>
                        
                         <th class=""><center>Sr. No.</center></th>
                        <th class=""><center>Roll No.</center></th>
                        <th class=""><center>Registration No.</center></th>
                        <th class=""><center>Name</center></th>
                        <th class=""><center>Division</center></th>
                        <th class=""  v-for="header,index in course_rubrics_list" :key="index">
                            <center>{{ header }}</center>
                        </th>
                       <th colspan="">
                            <center>Total</center>
                        </th>
                        <th colspan=""><center>%</center></th>
                        <th colspan=""><center>Grade</center></th>
                    </tr>
                    <tr v-for="(s, index) in learner_course_list" :key="s.lid">
                        <td>{{ index + 1 }}</td>
                        <td>{{ s.rollno }}</td>
                        <td>{{ s.registration_number }}</td>
                        <td>{{ s.name }}</td>
                        <td>
                            {{ s.division }}
                        </td>
                        <td v-for="(header, index) in s.comp_marks" :key="index">
                            <center>{{ header }}</center>
                        </td>
                        <td>{{ s.overall_marks }}</td>
                        <td>{{ s.final_converted_marks }}</td>
                        <td>{{ s.final_overall_grade }}</td>
                    </tr>
                </tbody>
            </v-simple-table>
            </div>
                    </div>
                </span>
            </span>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                overlay: false,
                selected: [],
                snackbar: false,
                course_list: [],
                crs_id: null,
                search: "",
                crs_list: [],
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                assessment_detail_list: [],
                assessment_detail: [],
                standard: null,
                division: null,
                course: null,
                ass_Scheme: null,
                academicyear: null,
                ass_detail_list: null,
                learner_course_list: [],
                inst_name: null,
                atotal: null,
                ass_converted_total: null,
                show: false,
                course_list: [],
                org_basic_data: [],
                default_value: null,
                rubrics_list_size:[],
                course_rubrics_list:[],
                crs_rubrics_list_size:[],
                crs_list:[],
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
            };
        },

        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },

            putallnull() {
                this.div_list = null;
                (this.assessment_detail_list = []), (this.assessment_detail = null);
            },
            putnull3() {
                this.show = false;
            },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putnull() {
                this.crs_list = [];
                this.crs_id = null;
            },
            putnull2() {
                (this.assessment_detail_list = []), (this.assessment_detail = null);
            },
            getassessmentschemedetails() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    sem: this.sem,
                };
                axios
                    .post("/Examination/getassschemedetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.assessment_detail_list = res.data.assessment_detail_list;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getreport() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    sem: this.sem,
                    div: this.div,
                    assessment_detail: this.assessment_detail.id,
                    status: this.status,
                };
                 this.fetch_loader = true;
                axios
                    .post("/Examination/allRubricsConsolidatedRport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.standard = res.data.standard;
                            this.division = res.data.div;
                            this.course = res.data.course;
                            this.ass_Scheme = res.data.ass_Scheme;
                            this.academicyear = res.data.ay;
                            this.learner_course_list = res.data.learner_course_list;
                            this.course_list = res.data.course_list;
                            this.rubrics_list_size = res.data.rubrics_list_size
                            this.course_rubrics_list = res.data.course_rubrics_list
                            this.org_basic_data = res.data.org_basic_data;
                            this.crs_rubrics_list_size = res.data.crs_rubrics_list_size
                            this.crs_list = res.data.crs_list
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            
                        }
                         this.show = true;
                         this.fetch_loader = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                         this.fetch_loader = false;
                        
                    })
                    .finally(() => {
                       this.fetch_loader = false;
                    });
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            CartPdf() {
                var tab = document.getElementById("tab");
                var tab1 = document.getElementById("tab1");
                var win = window.open("", "", "height=700,width=1000");
                win.document.write(tab.outerHTML, tab1.outerHTML);
                win.document.close();
                win.print();
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .table {
        border: none !important;
    }
    .scroll {
        overflow-x: scroll;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @media print {
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        img {
            width: 100% !important;
        }
        body,
        tr,
        th,
        td {
            font-size: small !important;
            font-weight: bold !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        table,
        td,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            font-weight: bold !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
        }
    }
</style>
